import React from "react";
import Container from "../componants/Container";
import DashboardContent from "./dashboard/Dashboardcontent";

const Dashboard = () => {
  return (
    <Container>
      <DashboardContent />
    </Container>
  );
};

export default Dashboard;
